<template>
	<div
		:class="[
			'login-page-container',
			{'sub-option' : $route.name === 'register' || $route.name === 'sign-in' || $route.name === 'forgot-password'},
			{'central' : $route.path.includes('forgot-password')}
		]"
	>
		<div class="login-image-container">
			<img
				ref="image"
				:src="isDesktopDevice ? vector : mobile"
				alt="vector"
			>
			<div ref="hover" class="hover"></div>
		</div>
		<div class="content-login">
			<h1>Welcome to Akkodis DRC-GOP Sales-Enablement Platforms</h1>
			<transition
				:mode="currentTransition.mode"
				:name="currentTransition.name"
				:duration="currentTransition.duration"
			>
				<router-view class="login-page-content"></router-view>
			</transition>
		</div>

		<HelperButton :hasResources="false" :hasContactCmt="false" :hasReportAProblem="false" />
	</div>
</template>

<script>
import displayResizeMixin from "@/drc/mixins/project-button-mixin";
import vector from "@/common/assets/images/login-vector.webp";
import shrinked from "@/common/assets/images/login-vector-shrinked.webp";
import mobile from "@/common/assets/images/login-vector-mobile.webp";
import {EventButton} from "@/common/configurations/event-bus";
import HelperButton from "@/common/components/HelperButton";

export default {
	name: "Login",
	mixins: [displayResizeMixin],
	components: {
		HelperButton
	},
	data() {
		return {
			vector: vector,
			shrinked: shrinked,
			mobile: mobile,
			transitions: {
				register: {
					name: 'hide-to-top-come-from-bottom',
					mode: 'out-in',
					duration: {enter: this.isDesktopDevice ? 300 : 200, leave: this.isDesktopDevice ? 300 : 200}
				},
				'login-options': {
					name: 'hide-to-right-come-from-left',
					mode: 'out-in',
					duration: {enter: 300, leave: 200},
				},
				'sign-in': {
					name: 'hide-to-top-come-from-bottom',
					mode: 'out-in',
					duration: {enter: this.isDesktopDevice ? 300 : 200, leave: this.isDesktopDevice ? 300 : 200}
				},
				'forgot-password': {
					name: 'hide-to-bottom-come-from-top',
					mode: 'out-in',
					duration: {enter: this.isDesktopDevice ? 300 : 200, leave: this.isDesktopDevice ? 300 : 200}
				},
				'register-success': {
					name: 'hide-to-bottom-come-from-top',
					mode: 'out-in',
					duration: {enter: this.isDesktopDevice ? 300 : 200, leave: this.isDesktopDevice ? 300 : 200}
				},
				'default': {
					name: 'hide-to-top-come-from-bottom',
					mode: 'out-in',
					duration: {enter: this.isDesktopDevice ? 300 : 200, leave: this.isDesktopDevice ? 300 : 200}
				}
			}
		}
	},
	mounted() {
		this.setUp();
		EventButton.$on("shrink", this.shrink);
		EventButton.$on("stretch", this.stretch);
	},
	beforeDestroy() {
		EventButton.$off("shrink");
		EventButton.$off("stretch");
	},
	computed: {
		currentTransition() {
			return this.transitions[this.$route.name] ? this.transitions[this.$route.name] : 'default'
		}
	},
	methods: {
		setUp() {
			if (this.$route.path.includes('/register') || this.$route.path.includes('/sign-in')) {
				this.shrink();
			}
		},
		shrink() {
			if (this.isDesktopDevice) {
				this.$refs.hover.style.width = "50%"
				this.$refs.image.style.width = "50%"
			} else {
				this.$refs.hover.style.height = "72vh"
				this.$refs.image.style.height = "28vh"
			}
			this.vector = shrinked;
		},
		stretch() {
			if (this.isDesktopDevice) {
				this.$refs.hover.style.width = "0%"
				this.$refs.image.style.width = "100%"
			} else {
				this.$refs.hover.style.height = "0vh"
				this.$refs.image.style.height = "55vh"
			}

			this.vector = vector
		},
		onResizing(value) {
			const isDesktopView = value;

			if (isDesktopView && this.$refs.image) {
				this.$refs.image.style.height = '100%';
				this.$refs.hover.style.height = '100%';
				this.$refs.hover.style.width = '0%';
			}

			if (isDesktopView && this.$refs.hover) {
				if ((this.$route.path.includes('/register') || this.$route.path.includes('/sign-in')) && this.$refs.hover.style.width === '0%') {
					this.shrink();
				}

				if ((!this.$route.path.includes('/register') && !this.$route.path.includes('/sign-in')) && this.$refs.hover.style.width !== '0%') {
					this.stretch();
				}

				if (this.$route.path.endsWith('/')) {
					this.$refs.image.style.width = '100%'
				}
			}

			if (!isDesktopView && (this.$route.path.includes('/register') || this.$route.path.includes('/sign-in'))) {
				this.$refs.hover.style.width = '100vh';

				this.shrink();
			}
		}
	},
	watch: {
		isDesktopDevice: {
			immediate: true,
			handler(value) {
				if (this.$router.previousRoute.name) {
					this.onResizing(value);
				} else {
					setTimeout(() => {
						this.onResizing(value);
					}, 300)
				}

			}
		}
	}
}
</script>

<style lang="scss" scoped>
@import '@/common/assets/css/_variables.scss';

.login-page-container {
	min-height: 100vh;
	width: 100%;
	background-color: $drc-dark-blue;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	gap: 30px;
	padding-left: 5%;
	padding-right: 5%;
	position: relative;
	scrollbar-width: none;

	&::-webkit-scrollbar {
		display: none;
	}

	@media (max-width: $tablet) {
		justify-content: center;
		overflow: hidden;
	}

	@media (max-width: $mobile) {
		overflow: scroll;
	}

	.login-image-container {
		display: flex;
		flex-direction: row;
		flex-wrap: nowrap;
		max-width: 1160px;
		width: 100%;
		max-height: 580px;
		height: 40vw;
		position: relative;

		@media (max-width: $tablet) {
			position: absolute;
			top: 0;
			height: unset;
			max-width: unset;
			max-height: unset;

			flex-direction: column;
		}

		&:before {
			content: "";
			position: absolute;
			top: 0;
			left: -6vw;
			border-left: 6vw solid transparent;
			border-top: 6vw solid $drc-dark-blue;
			border-right: 6vw solid transparent;
			width: 0;
			height: 0;

			@media (max-width: $tablet) {
				display: none;
			}

			@media (min-width: 2500px) {
				left: -100px;
				border-left: 100px solid transparent;
				border-top: 100px solid $drc-dark-blue;
				border-right: 100px solid transparent;
			}
		}

		img {
			width: 100%;
			height: 100%;
			transition: width 0.5s ease, height 0.5s ease;

			@media (max-width: $tablet) {
				object-fit: cover;
				height: 55vh;
				width: 100% !important;
			}
		}

		.hover {
			height: 100%;
			width: 1px;
			background: linear-gradient(180deg, rgba(0, 31, 51, 0) 0%, rgba(0, 31, 51, 1) 0%, rgba(0, 31, 51, 1) 4%);
			transition: width 0.5s ease, height 0.5s ease;

			@media (max-width: $tablet) {
				width: 100%;
			}
		}
	}

	.content-login {
		position: absolute;
		width: 100%;
		max-width: 1048px;
		max-height: 524px;
		display: flex;
		flex-direction: row;
		flex-wrap: nowrap;
		justify-content: center;
		align-items: center;
		gap: 80px;
		padding-left: 40px;
		padding-right: 40px;

		@media (max-width: 1175px) {
			padding-left: 50px;
			padding-right: 50px;
			gap: 5%;
		}

		@media (max-width: 1145px) {
			padding-left: 60px;
			padding-right: 60px;
		}

		@media (max-width: 1125px) {
			padding-left: 80px;
			padding-right: 80px;
		}

		@media (max-width: $tablet) {
			position: relative;
			flex-direction: column;
			height: 100%;
			padding-left: 0;
			padding-right: 0;
			max-height: unset;
			max-width: 100%;
			gap: 0;
		}

		@media (max-width: $mobile) {
			height: fit-content;
		}

		// fade to right
		.hide-to-right-come-from-left-enter-active {
			transition: transform 0.3s ease, opacity 0.3s ease;
		}

		.hide-to-right-come-from-left-leave-active {
			transition: transform 0.3s ease, opacity 0.3s ease;
		}

		.hide-to-right-come-from-left-enter {
			transform: translate(-100%, 20%);
			opacity: 0;
		}

		.hide-to-right-come-from-left-leave-to {
			transform: translate(100%, 0);
			opacity: 0;
		}

		// end - fade to right

		// fade to left
		.hide-to-left-come-from-right-enter-active {
			transition: transform 0.3s ease, opacity 0.3s ease;
		}

		.hide-to-left-come-from-right-leave-active {
			transition: transform 0.3s ease, opacity 0.3s ease;
		}

		.hide-to-left-come-from-right-enter {
			transform: translate(100%, 20%);
			opacity: 0;
		}

		.hide-to-left-come-from-right-leave-to {
			transform: translate(-100%, 0);
			opacity: 0;
		}

		// end - fade to left


		.hide-to-top-come-from-bottom-enter-active, .hide-to-top-come-from-bottom-leave-active {
			transition-property: opacity, transform;
		}

		.hide-to-top-come-from-bottom-enter-active {
			transition: all 0.3s ease;
		}

		.hide-to-top-come-from-bottom-leave-active {
			transition: all 0.3s ease;
			opacity: 1;
			transform: translateY(0);
		}

		.hide-to-top-come-from-bottom-enter {
			opacity: 0;
			transform: translateY(100%);
		}

		.hide-to-top-come-from-bottom-enter-to {
			opacity: 1;
			transform: translateY(0);
		}

		.hide-to-top-come-from-bottom-leave-to {
			opacity: 0;
			transform: translateY(-100%);
		}


		//fade to left
		.hide-to-bottom-come-from-top-enter-active, .hide-to-bottom-come-from-top-leave-active {
			transition-property: opacity, transform;
		}

		.hide-to-bottom-come-from-top-enter-active {
			transition: all 0.3s ease;
		}

		.hide-to-bottom-come-from-top-leave-active {
			transition: all 0.3s ease;
			opacity: 1;
			transform: translateY(0);
		}

		.hide-to-bottom-come-from-top-enter {
			opacity: 0;
			transform: translateY(-100%);
		}

		.hide-to-bottom-come-from-top-enter-to {
			opacity: 1;
			transform: translateY(0);
		}

		.hide-to-bottom-come-from-top-leave-to {
			opacity: 0;
			transform: translateY(100%);
		}

		//end - fade to left


		h1, div {
			height: 100%;
			width: 45%;

			@media (max-width: $tablet) {
				width: 100%;
				max-width: 480px;
			}
		}

		h1 {
			font-family: Tiempos Headline, serif;
			font-size: 32px;
			font-weight: 400;
			line-height: 40px;
			letter-spacing: 0.36px;
			text-align: left;
			color: white;
			align-self: center;
			display: flex;
			flex-direction: column;
			justify-content: center;
			opacity: 1;
			transition: transform 0.4s ease, font-size 0.4s ease,  opacity 0.4s ease;

			@media (max-width: $tablet) {
				height: unset;
				transform: translateY(140px) translateX(0);
			}

			@media (max-width: 750px) {
				transform: translateY(-12px) translateX(0);
			}
		}

		.login-page-content {
			width: 40%;
			align-items: center;

			@media (max-width: $tablet) {
				width: 100%;
				height: unset;
				min-height: 568px;
			}

			@media (max-width: 750px) {
				min-height: 305px;
				height: 305px;
			}

			@media (max-width: $mobile) {
				width: 100%;
				min-height: unset;
			}
		}

	}

	button {
		padding: 14px 18px;
		min-width: 200px;
		text-transform: uppercase;
		cursor: pointer;
	}
}

.sub-option {
	@media (min-width: 1025px) and (max-height: 570px) {
		padding-top: 80px;
	}

	.login-image-container {
		width: 100%;
		opacity: 1;
		transition: width 0.5s ease, opacity 0.5s ease;

		&:after {
			content: '';
			position: absolute;
			z-index: 1;
			opacity: 0.5;
			top: 0;
			right: 0;
			background: $drc-dark-blue;
			width: 100%;
			height: 100%;
		}
	}

	.content-login {
		z-index: 2;

		h1 {
			transform: translateY(200px) translateX(-16%);

			@media (max-width: 1240px) {
				transform: translateY(200px) translateX(-12%);
			}

			@media (max-width: 1165px) {
				transform: translateY(200px) translateX(-6%);
			}

			@media (max-width: $tablet) {
				transform: translateY(0px) translateX(-50px) scale(0.8);
				transition: font-size 0.5s ease-in, transform 0.5s ease, height 0.5s ease, opacity 0.5s ease;
			}

			@media (max-width: $mobile) {
				display: none;
			}
		}

		.login-page-content {
			width: 45%;

			@media (max-width: $tablet) {
				width: 100%;
			}

			@media (max-width: 750px) {
				min-height: unset;
				height: fit-content;
			}
		}
	}

}

.central {
	.login-image-container {
		width: 0;
		opacity: 0;
	}

	.content-login {
		h1 {
			position: absolute;
			visibility: hidden;
			opacity: 0;
		}
	}
}

</style>
